// src/components/auth/Login.js
import React, { useState } from "react";
import { signup } from "../../api/auth";
import { useNavigate } from 'react-router-dom';
import { useUser } from "../../api/AuthContext";
import Footer from "../Shared/Footer";


const Signup = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [first_name, setFirstName] = useState("");
  const [last_name, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [error, setError] = useState("");
  const { setUser } = useUser();

  const handleSignup = async (event) => {
    event.preventDefault();
    try {
      await signup(username,first_name, last_name, email, mobile, password, dateOfBirth);
      navigate('/login?signup=success');
    } catch (err) {
      setError(err);
    }
  };

  return (
    <div>
      <section className="breadcrumb-section pt-0">
        <div className="container-fluid-lg">
            <div className="row">
                <div className="col-12">
                    <div className="breadcrumb-contain">
                        <h2 className="mb-2">Sign Up</h2>
                        <nav>
                            <ol className="breadcrumb mb-0">
                                <li className="breadcrumb-item">
                                    <a href="/">
                                        <i className="fa-solid fa-house"></i>
                                    </a>
                                </li>
                                <li className="breadcrumb-item active">Sign Up</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    </section>
    {/* <!-- Breadcrumb Section End --> */}

    {/* <!-- log in section start --> */}
    <section className="log-in-section background-image-2 section-b-space">
        <div className="container-fluid-lg w-100">
            <div className="row">
                <div className="col-xxl-6 col-xl-5 col-lg-6 d-lg-block d-none ms-auto">
                    <div className="image-contain">
                        <img src="../assets/images/inner-page/login.png" className="img-fluid" alt="" />
                    </div>
                </div>

                <div className="col-xxl-4 col-xl-5 col-lg-6 col-sm-8 mx-auto">
                    <div className="log-in-box">
                        <div className="log-in-title">
                            <h3>Welcome To Reducarb</h3>
                            <h4>Please enter details to Signup</h4>
                        </div>

                        <div className="input-box">
                            <form className="row g-4" onSubmit={handleSignup}>
                                <div className="col-12">
                                    <div className="form-floating theme-form-floating log-in-form">
                                        <input type="text" placeholder="Username" className="form-control" value={username} onChange={(e) => setUsername(e.target.value)} required/>
                                        {/* <label htmlFor="username">Username</label> */}
                                    </div>
                                </div>

                                <div className="col-12">
                                    <div className="form-floating theme-form-floating log-in-form">
                                        <input type="text" className="form-control" placeholder="First Name" value={first_name} onChange={(e) => setFirstName(e.target.value)} required/>
                                        {/* <label htmlFor="first_name">First Name</label> */}
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="form-floating theme-form-floating log-in-form">
                                        <input type="text" className="form-control" placeholder="Last Name" value={last_name} onChange={(e) => setLastName(e.target.value)} required/>
                                        {/* <label htmlFor="last_name">Last Name</label> */}
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="form-floating theme-form-floating log-in-form">
                                        <input type="email" className="form-control" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required/>
                                        {/* <label htmlFor="email">Email</label> */}
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="form-floating theme-form-floating log-in-form">
                                        <input type="number" className="form-control" placeholder="Mobile No" value={mobile} onChange={(e) => setMobile(e.target.value)} required/>
                                        {/* <label htmlFor="mobile">Mobile</label> */}
                                    </div>
                                </div>
                                {/* <div className="col-12">
    <div className="form-floating theme-form-floating log-in-form">
        <input
            type="date"
            className="form-control"
            value={dateOfBirth}
            onChange={(e) => setDateOfBirth(e.target.value)}
        />
        <label htmlFor="dateOfBirth">Date of Birth</label>
    </div>
</div> */}
                                <div className="col-12">
                                    <div className="form-floating theme-form-floating log-in-form">
                                        <input type="password" className="form-control" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
                                        {/* <label htmlFor="mobile">Mobile</label> */}
                                    </div>
                                </div>

                                <div className="col-12">
                                    <div className="forgot-box">
                                        <div className="form-check ps-0 m-0 remember-box">
                                            {/* <input className="checkbox_animated check-box" type="checkbox"
                                                id="flexCheckDefault" />
                                            <label className="form-check-label" htmlFor="flexCheckDefault">Remember me</label> */}
                                        </div>
                                        <a href="/forgot-password" className="forgot-password">Forgot Password?</a>
                                    </div>
                                </div>

                                <div className="col-12">
                                    <button className="btn btn-md cart-button text-white w-100 justify-content-center"
                                    
                                    style={{
                                      backgroundColor: "#3150A3",
                                      fontWeight: "bold",
                                    }} type="submit">Sign Up</button>
                                    {error && <p style={{ color: "red" }}>{error}</p>}
                                </div>
                            </form>
                        </div>


                        <div className="sign-up-box">
                            <h4>Already have an account?</h4>
                            <a href="login">Login</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    {/* <!-- log in section end --> */}
    <Footer/>
    </div>
  );
};

export default Signup;
